<div [formGroup]="formGroup" class="pure-g">
    <!-- Mode -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-select ngDefaultControl label="Mode" formControlName="repairMode" [disabled]="isEditMode"
            [attr.invalid]="isControlInErrorState(formGroup.controls['repairMode'])" fit="small"
            placeholder="Select a mode" (optionselected)="onModeChange($event)" required>
            @for (mode of repairModeList; track mode.code) {
                <mc-option [value]="mode.code">{{ mode.code }} - {{ mode.description }}</mc-option>
            }
            @if(formGroup.get('repairMode')?.hasError('required')){
                <span slot="errormessage">Mode is required</span>
            }
        </mc-select>
    </div>

    <!-- Repair Code -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-input ngDefaultControl label="Repair Code" formControlName="repairCode" [disabled]="isEditMode"
            [attr.invalid]="isControlInErrorState(formGroup.controls['repairCode'])" fit="small"
            maxlength="4" required>
            @if(formGroup.get('repairCode')?.hasError('required')){
                <span slot="errormessage">Repair Code is required</span>
            }
            @if(formGroup.get('repairCode')?.hasError('minlength') || formGroup.get('repairCode')?.hasError('maxlength')){
                <span slot="errormessage">Repair Code must be exactly 4 characters</span>
            }
        </mc-input>
    </div>

    <!-- Repair Code Description -->
    <div class="pure-u-1 p-r-8 p-b-16">
        <mc-textarea ngDefaultControl label="Repair Code Description" formControlName="description"
            [attr.invalid]="isControlInErrorState(formGroup.controls['description'])" fit="small"
            maxlength="100" [charactercount]="true" required>
            @if(formGroup.get('description')?.hasError('required')){
                <span slot="errormessage">Description is required</span>
            }
        </mc-textarea>
    </div>

    <!-- Man Hour -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-input ngDefaultControl label="Man Hour" formControlName="maxLabourHours"
            [attr.invalid]="isControlInErrorState(formGroup.controls['maxLabourHours'])"
            fit="small" type="number" min="0">
            @if(formGroup.get('maxLabourHours')?.hasError('min')){
                <span slot="errormessage">Man Hour must be 0 or greater</span>
            }
        </mc-input>
    </div>

    <!-- Max Quantity -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-input ngDefaultControl label="Max Quantity" formControlName="maxQuantity"
            [attr.invalid]="isControlInErrorState(formGroup.controls['maxQuantity'])"
            fit="small" type="number" min="0">
            @if(formGroup.get('maxQuantity')?.hasError('min')){
                <span slot="errormessage">Max Quantity must be 0 or greater</span>
            }
        </mc-input>
    </div>

    <!-- Shop Material Ceiling -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-input ngDefaultControl label="Shop Material Ceiling" formControlName="maxMaterialPrice"
            [attr.invalid]="isControlInErrorState(formGroup.controls['maxMaterialPrice'])"
            fit="small" type="number" min="0">
            @if(formGroup.get('maxMaterialPrice')?.hasError('min')){
                <span slot="errormessage">Shop Material Ceiling must be 0 or greater</span>
            }
        </mc-input>
    </div>

    <!-- Spacer -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16"></div>

    <!-- Toggle Switches -->
    <div class="pure-u-1 p-r-8 p-b-16 p-t-16">
        <div style="display: flex; gap: 32px; flex-wrap: wrap; align-items: center;">
            <mc-switch ngDefaultControl label="Exclude Prep Hours" formControlName="excludePreparationHours"
                [checked]="formGroup.get('excludePreparationHours')?.value || false"
                (change)="onSwitchChange($event, 'excludePreparationHours')"
                fit="small">
            </mc-switch>
            <mc-switch ngDefaultControl label="Apply Tax" formControlName="taxApplied"
                [checked]="formGroup.get('taxApplied')?.value || false"
                (change)="onSwitchChange($event, 'taxApplied')"
                fit="small">
            </mc-switch>
            <mc-switch ngDefaultControl label="Repair Active" formControlName="isActive"
                [checked]="formGroup.get('isActive')?.value || false"
                (change)="onSwitchChange($event, 'isActive')"
                fit="small">
            </mc-switch>
            <mc-switch ngDefaultControl label="Allow Parts" formControlName="allowParts"
                [checked]="formGroup.get('allowParts')?.value || false"
                (change)="onSwitchChange($event, 'allowParts')"
                fit="small">
            </mc-switch>
            <mc-switch ngDefaultControl label="Multiple EQ" formControlName="multipleEq"
                [checked]="formGroup.get('multipleEq')?.value || false"
                (change)="onSwitchChange($event, 'multipleEq')"
                fit="small">
            </mc-switch>
        </div>
    </div>
</div>
